import { computed, flow, makeObservable, observable } from 'mobx'

import { requestWrapper } from 'Shared/utils'

import { CustomGenerator } from 'Core/interfaces'
import { entityToLabelValue, getDefaultStoreArrayValue } from 'Core/utils'
import { formatDataToLabelValue } from 'Core/utils'

import { MetadataRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

// Order of languages in DB doesn't correspond to order in requirements
export const ORDERED_LANGUAGES = [
	'English',
	'Spanish',
	'Turkish',
	'Portuguese',
	'Chinese - Mandarin'
]

export class MetadataStore {
	@observable accessor languages = getDefaultStoreArrayValue<Entity>()
	@observable accessor unitsOfMeasure = getDefaultStoreArrayValue<Entity>()
	@observable accessor countries = getDefaultStoreArrayValue<CodeEntity>()

	constructor(public rootStore: RootStore) {
	}

	@computed
	get languageOptions() {
		return formatDataToLabelValue(this.languages.value)
	}

	@computed
	get unitsOfMeasureOptions() {
		return this.unitsOfMeasure.value.map(entityToLabelValue)
	}

	@flow.bound
	*retrieveLanguages(): CustomGenerator<Entity[]> {
		const data = yield requestWrapper({
			field: this.languages,
			repository: MetadataRepo.retrieveLanguages,
			repositoryParams: null
		})

		data.sort((a, b) => ORDERED_LANGUAGES.indexOf(a.name) - ORDERED_LANGUAGES.indexOf(b.name))

		this.languages.value = data
	}

	@flow.bound
	*retrieveUnitsOfMeasure(): CustomGenerator<Entity[]> {
		yield requestWrapper({
			field: this.unitsOfMeasure,
			repository: MetadataRepo.retrieveUnitsOfMeasure,
			repositoryParams: null
		})
	}

	@flow.bound
	*retrieveCountries(): CustomGenerator<CodeEntity[]> {
		yield requestWrapper({
			field: this.countries,
			repository: MetadataRepo.retrieveCountries,
			repositoryParams: null
		})
	}
}
